import clsx from 'clsx';
import { type MutableRefObject, useContext } from 'react';
import { ComboBoxStateContext as RACComboBoxStateContext, Input as RACInput } from 'react-aria-components';
import { useLocalizedMessages } from '../../i18n/localization-provider.js';
import { textStyle } from '../typography/utils.js';

/** @internal */
export function TagFieldInput({
  inputRef,
  isReadOnly,
  placeholder,
}: {
  inputRef: MutableRefObject<HTMLInputElement | null>;
  isReadOnly: boolean | undefined;
  placeholder: string | undefined;
}) {
  const comboBoxState = useContext(RACComboBoxStateContext);
  const messages = useLocalizedMessages('tagField');

  const selectedItemCount = comboBoxState?.selectedItems.length ?? 0;

  return (
    <RACInput
      ref={inputRef}
      className={clsx('cim-combo-box-input', textStyle({ variant: 'body' }))}
      // Ensure the popover opens when the input is clicked.
      // By default, React Aria only opens the popover when the input is focused.
      onClick={() => !isReadOnly && comboBoxState!.open()}
      placeholder={
        selectedItemCount === 0 && placeholder ? placeholder : messages.format('itemsSelected', { selectedItemCount })
      }
    />
  );
}
